import React, { useState } from "react";

import {
  FontIcon,
  IconButton,
  mergeStyleSets,
  Stack,
  Text,
  TooltipHost,
  useTheme
} from "@bps/fluent-ui";
import { dangerButtonStyles } from "@components/buttons/DangerButton";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { DeploymentRing } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { DeleteRingDialog } from "./edit/DeleteRingDialog";
import { EditRingDialog } from "./edit/EditRingDialog";

interface RingListItemProps {
  ring: DeploymentRing;
}

export const RingListItem: React.FC<RingListItemProps> = ({ ring }) => {
  const theme = useTheme();

  const { data: hasDeployPermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementDeploy
  );

  const [showEdit, setShowEdit] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  return (
    <Stack>
      <EditRingDialog
        ring={ring}
        hidden={!showEdit}
        onDismiss={() => setShowEdit(false)}
      />
      <DeleteRingDialog
        ringId={ring.id}
        hidden={!showDelete}
        onCancel={() => setShowDelete(false)}
      />
      <Stack
        horizontal
        horizontalAlign="space-between"
        verticalAlign="center"
        styles={{
          root: {
            "& .RingListItemActions": {
              opacity: 0
            },
            "&:hover .RingListItemActions": {
              opacity: 1
            }
          }
        }}
      >
        {ring.isSystemManaged && (
          <TooltipHost content="System Managed">
            <FontIcon
              iconName="System"
              styles={{
                root: {
                  color: theme.palette.orangeLight,
                  fontSize: 18,
                  padding: theme.spacing.s2
                }
              }}
            />
          </TooltipHost>
        )}
        <Text>{ring.displayName}</Text>

        {!ring.isSystemManaged && (
          <Stack
            className="RingListItemActions"
            horizontal
            tokens={{ childrenGap: theme.spacing.s2 }}
          >
            <IconButton
              as="div"
              onClick={e => {
                e.stopPropagation();
                setShowEdit(true);
              }}
              iconProps={{
                iconName: "Edit"
              }}
              styles={{
                rootHovered: {
                  borderColor:
                    theme.semanticColors.listItemBackgroundCheckedHovered,
                  background:
                    theme.semanticColors.listItemBackgroundCheckedHovered
                }
              }}
              disabled={!hasDeployPermission}
              title={!hasDeployPermission ? NO_ACTION_PERMISSION : undefined}
            />
            <IconButton
              onClick={e => {
                e.stopPropagation();
                setShowDelete(true);
              }}
              styles={mergeStyleSets(dangerButtonStyles(theme), {
                root: {
                  background: "transparent"
                }
              })}
              iconProps={{
                iconName: "Cancel"
              }}
              disabled={!hasDeployPermission}
              title={!hasDeployPermission ? NO_ACTION_PERMISSION : undefined}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
